import React, { useId } from "react";

// Farbige Pinselstriche an den Ecken einer Sektion (angelehnt an das Original-Design)
const PaintEdges = ({
  from = "#1b9ad6",
  via = "#3ec6c0",
  to = "#7cc24a",
  opacity = 0.75,
}) => {
  const id = useId().replace(/:/g, "");
  const g1 = `pg1${id}`;
  const g2 = `pg2${id}`;

  const Stroke = ({ className }) => (
    <svg className={className} viewBox="0 0 600 300" fill="none" aria-hidden="true">
      <defs>
        <linearGradient id={g1} x1="0" y1="0" x2="600" y2="0" gradientUnits="userSpaceOnUse">
          <stop stopColor={from} />
          <stop offset="0.5" stopColor={via} />
          <stop offset="1" stopColor={to} />
        </linearGradient>
        <linearGradient id={g2} x1="0" y1="0" x2="600" y2="0" gradientUnits="userSpaceOnUse">
          <stop stopColor={to} />
          <stop offset="0.5" stopColor={via} />
          <stop offset="1" stopColor={from} />
        </linearGradient>
      </defs>
      <path
        d="M-30 236 C 130 170, 320 262, 640 108 L640 152 C 330 310, 140 214, -30 282 Z"
        fill={`url(#${g1})`}
        opacity="0.6"
      />
      <path
        d="M-30 190 C 160 120, 330 226, 640 60 L640 90 C 340 250, 170 160, -30 224 Z"
        fill={`url(#${g2})`}
        opacity="0.45"
      />
      <path
        d="M-30 268 C 150 208, 310 288, 640 168"
        stroke={to}
        strokeWidth="7"
        strokeLinecap="round"
        opacity="0.7"
      />
      <path
        d="M-30 160 C 170 96, 340 200, 640 34"
        stroke={from}
        strokeWidth="5"
        strokeLinecap="round"
        opacity="0.55"
      />
      <path
        d="M-30 120 C 180 70, 350 160, 640 12"
        stroke={via}
        strokeWidth="3"
        strokeLinecap="round"
        opacity="0.5"
      />
    </svg>
  );

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" style={{ opacity }} aria-hidden="true">
      <Stroke className="absolute -top-8 -left-16 w-[560px] max-w-none rotate-180" />
      <Stroke className="absolute -bottom-10 -right-16 w-[560px] max-w-none" />
    </div>
  );
};

export default PaintEdges;
